import UtilService from "../../../../services/util";

/** 
 * Informações das colunas para lista de filiais
 * @type {{
 *   groups: Array<{
 *      header: string,
 *      fields: Array<{
 *        label: string,
 *        placeholder: string,
 *        name: string,
 *        type: string,
 *        size: number,
 *        className: string
 *      }>
 *   }
 * }>} 
*/
export const getFormFields = async () => {
    return {
        groups: [
            {
                header: '',
                shouldRender: (form) => {
                    return ![null, undefined].includes(form.cod);
                },
                fields: [
                    {
                        label: 'Código',
                        placeholder: '',
                        name: 'cod',
                        type: 'text',
                        size: 3,
                        readOnly: true
                    },
                ]

            },
            {
                header: 'Informações Cadastrais',
                fields: [
                    {
                        label: 'CBO',
                        placeholder: 'Ex:',
                        name: 'cbo',
                        type: 'text',
                        size: 3,
                        max: 10,
                        readOnly: true,
                        disabled: true
                    },
                    {
                        label: 'Nome',
                        placeholder: 'Ex: Assistente de vendas',
                        name: 'nome',
                        type: 'text',
                        size: 4,
                        max: 60,
                        readOnly: true,
                        disabled: true
                    },
                ]
            },
            {
                header: '', 
                fields: [
                    {
                        label: 'Descrição',
                        placeholder: 'Digite aqui descrição, observações ou detalhes...',
                        name: 'descricao',
                        type: 'textarea',
                        size: 6,
                        max: 300
                    },
                ]
            },
            {
                header: 'Ativação',
                fields: [
                    {
                        label: 'Cadastro Ativo',
                        placeholder: '',
                        name: 'ativo',
                        type: 'swicth',
                        defaultChecked: true,
                        defaultValue: true,
                        size: 2,
                    },
                ]
            }
        ]
    };
}

const ColaboradorNewInfo = { getFormFields };

export default ColaboradorNewInfo;
